import React, { useEffect, useState } from 'react';
import { TabData } from '../types/types';
import { text } from '../data';
import Tabs from '../components/Tabs';
import SpecificationSearch from './specification-search/SpecificationSearch';
import PartNumberSearch from './part-number-search/PartNumberSearch';
import InterchangeSearch from './interchange-search/InterchangeSearch';
import { trackStart } from '../utils/analytics';

const SealSearch: React.FC = () => {
	const tabs: TabData[] = [
		{
			id: 'by_specifications',
			title: text.bySpecs,
			content: <SpecificationSearch />,
		},
		{
			id: 'by_part_number',
			title: text.byPartNumber,
			content: <PartNumberSearch />,
		},
		{
			id: 'competitor_interchange',
			title: text.competitorInterchange,
			content: <InterchangeSearch />,
		},
	];

	const [ activeSearchTab, setActiveSearchTab ] = useState( 'by_specifications' );

	useEffect( () => {
		trackStart( 'sealSearch' );
	}, [] );

	const handleTabChange = ( id: string ) => {
		setActiveSearchTab( id );
	};

	return (
		<Tabs
			title={text.searchOptions}
			tabs={tabs}
			defaultTab={activeSearchTab}
			onChange={handleTabChange}
		/>
	);
};

export default SealSearch;
